/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigCompletionMinLevelsEffectiveAnyOf } from './taskEvaluationConfigCompletionMinLevelsEffectiveAnyOf';

export type TaskEvaluationConfigCompletionMinLevelsEffective =
  TaskEvaluationConfigCompletionMinLevelsEffectiveAnyOf | null;
